import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Workspace } from '@clarix/shared-types';

interface WorkspaceState {
  current: Workspace | null;
  available: readonly Workspace[];
}

const initialState: WorkspaceState = {
  current: { id: 'dev-workspace', slug: 'dev-workspace', name: 'Dev Workspace' },
  available: [{ id: 'dev-workspace', slug: 'dev-workspace', name: 'Dev Workspace' }],
};

// TODO: replace placeholder current/available with backend-driven data in M1.

const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    setCurrent(state, action: PayloadAction<Workspace>) {
      state.current = action.payload;
    },
    setAvailable(state, action: PayloadAction<readonly Workspace[]>) {
      state.available = [...action.payload];
    },
  },
});

export const { setCurrent, setAvailable } = workspaceSlice.actions;
export const workspaceReducer = workspaceSlice.reducer;
export type { WorkspaceState };
